import React, { useState } from 'react'
import Header from './Header'
import Footer from './Footer'

const Register = () => {
 /* let [fname,setFname] = useState('')
  let [lname,setLname] = useState('')
  let [email,setEmail] = useState('')
  let [phone,setPhone] = useState('')
  let [password,setPassword] = useState('')
*/

  let [data,setData] = useState({
      fname:"",
      lname:"",
      email:"",
      phone:"",
      password:""
  })

  let changeFname = (e)=>{
    setData({
      ...data,
      fname:e.target.value
    
  })
  
  }

  let changeLname = (e)=>{
    setData({
      ...data,
      lname:e.target.value
    
  })
  
  }

  let changeEmail = (e)=>{
    setData({
      ...data,
      email:e.target.value
    
  })
  
  }

  let changePhone = (e)=>{
    setData({
      ...data,
      phone:e.target.value
    
  })
  
  }

  let changePassword = (e)=>{
    setData({
      ...data,
      password:e.target.value
    
  })
  
  }


  let register = (e)=>{
    e.preventDefault()
    console.log(data)
  }


  return (
    <> 
      <Header />
      <div className="container">
        <div className="row mt-5">
          <div className="col-md-6 mx-auto">
            <div className="card">
              <div className="card-header">
                <h1>Register </h1>
                <p>{JSON.stringify(data)}</p>
              </div>
              <div className="card-body">
                <form>
                  <div className="mb-3 mt-3">
                    <label htmlFor="fname" className="form-label">FirstName: </label>
                    <input type="text" className="form-control" placeholder="Enter enter FName" name="fname" onChange={changeFname}/>
                  </div>

                  <div className="mb-3">
                    <label htmlFor="lname" className="form-label">LastName: </label>
                    <input type="text" className="form-control" placeholder="Enter enter Lname" name="lname" onChange={changeLname} />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">Email: </label>
                    <input type="email" className="form-control" placeholder="Enter enter Email" name="email"  onChange={changeEmail}/>
                  </div>

                  <div className="mb-3">
                    <label htmlFor="phone" className="form-label">Phone: </label>
                    <input type="number" className="form-control" placeholder="Enter enter Phone" name="phone"  onChange={changePhone}/>
                  </div>

                  <div className="mb-3">
                    <label htmlFor="password" className="form-label">Password: </label>
                    <input type="password" className="form-control" placeholder="Enter enter password" name="password"  onChange={changePassword}/>
                  </div>

                  <button type="submit" class="btn btn-primary me-2" onClick={register}>Register</button>
                  <button type="reset" class="btn btn-danger">Cancel</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default Register
